import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {useHistory} from 'react-router-dom';
import cx from 'classnames';
import qs from 'qs';
import {validators} from './validators';

class SandboxFormWithoutRouter extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      submitting: false,
      errors: {},
      values: {
        plan: 'sandbox',
        companyName: '',
        firstName: '',
        lastName: '',
        email: '',
      },
    };
  }

  handleInputChange(event) {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({
      values: Object.assign(this.state.values, {
        [fieldName]: fieldValue,
      }),
    });
  }

  handleInputBlur(event) {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    if (validators[fieldName]) {
      this.setState({
        errors: Object.assign(this.state.errors, {
          [fieldName]: validators[fieldName].call(this, fieldValue),
        }),
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const errors = {};

    Object.keys(validators).forEach(fieldName => {
      const error = validators[fieldName].call(undefined, this.state.values[fieldName]);
      if (error) errors[fieldName] = error;
    });

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({
      submitting: true,
    });

    const endpoint = `https://${process.env.REACT_APP_API_HOST}/admin/signup`;

    axios.post(endpoint, this.state.values)
      .then(response => {
        let targetUrl = `/sandbox/completed`;
        if (this.state.values.id !== undefined) {
          const querystring = {};
          if (response.data.mandateUrl) querystring.mandateUrl = response.data.mandateUrl;
          targetUrl = targetUrl.concat('?').concat(qs.stringify(querystring));
        }
        this.setState({
          submitting: false,
        });
        this.props.router.push(targetUrl);
      })
      .catch(err => {
        if (err.response.status === 400 && err.response.data[0].param !== 'client') {
          const errors = {};
          err.response.data.forEach(error => {
            errors[error.param] = 'Ongeldige waarde';
          });
          this.setState({
            submitting: false,
            errors,
          });
        } else {
          this.props.router.push(`/signup/failed`);
        }
      });
  }

  render() {
    return (
      <form onSubmit={ this.handleSubmit } className="form">
        <fieldset>
          <div className="formGroup">
            <label>Voor- en achternaam</label>
            <div className="FormInlineGroup">
              <div className={ cx('FormInput', { '-hasError': this.state.errors['firstName'] })}>
                <input name="firstName"
                       value={ this.state.values.firstName }
                       onChange={ this.handleInputChange }
                       onBlur={ this.handleInputBlur } />
                { this.state.errors['firstName'] &&
                <div className="FormError">{ this.state.errors['firstName'] }</div>
                }
              </div>
              <div className={ cx('FormInput', { '-hasError': this.state.errors['lastName'] })}>
                <input name="lastName"
                       value={ this.state.values.lastName }
                       onChange={ this.handleInputChange }
                       onBlur={ this.handleInputBlur } />
                { this.state.errors['lastName'] &&
                <div className="FormError">{ this.state.errors['lastName'] }</div>
                }
              </div>
            </div>
          </div>
          <div className="formGroup">
            <label>Bedrijfsnaam</label>
            <div className={ cx('FormInput', { '-hasError': this.state.errors['companyName'] })}>
              <input name="companyName"
                      value={ this.state.values.companyName }
                      onChange={ this.handleInputChange }
                      onBlur={ this.handleInputBlur } />
              { this.state.errors['companyName'] &&
              <div className="FormError">{ this.state.errors['companyName'] }</div>
              }
            </div>
          </div>
          <div className="formGroup">
            <label>E-mailadres</label>
            <div className={ cx('FormInput', { '-hasError': this.state.errors['email'] })}>
              <input name="email"
                     value={ this.state.values.email }
                     onChange={ this.handleInputChange }
                     onBlur={ this.handleInputBlur } />
              { this.state.errors['email'] &&
              <div className="FormError">{ this.state.errors['email'] }</div>
              }
            </div>
          </div>
          <div className="formButtonWrapper">
            <p>Door te klikken op ‘registreren’ ga je akkoord met onze <a href="/algemene-voorwaarden" target="_blank">algemene voorwaarden.</a></p>
            { !this.state.submitting &&
            <button type='submit' className={ cx( 'formBtn', "button", "buttonCta" ) }>Registreren</button>
            }
            { this.state.submitting &&
            <p>Een moment geduld...</p>
            }
          </div>
        </fieldset>
      </form>
    );
  }
}
SandboxFormWithoutRouter.propTypes = {
  router: PropTypes.object.isRequired
}

const SandboxForm = () => {
  const router = useHistory();
  return (
    <SandboxFormWithoutRouter router={router} />
  )
};

export default SandboxForm;
